// App version - manually bump this with each release
export const APP_VERSION = "1.0.0";

// Build timestamp - auto-injected at build time by Vite
// @ts-ignore - This is replaced at build time by Vite
export const BUILD_DATE: string = __BUILD_DATE__;

// Build hash - unique identifier per build, auto-injected by Vite
// @ts-ignore - This is replaced at build time by Vite
export const BUILD_HASH: string = __BUILD_HASH__;

// Combined version string for display
export const FULL_VERSION = `${APP_VERSION}+${BUILD_HASH}`;

// Environment
export const APP_ENV = import.meta.env.MODE;

// Helper to check if running newer build
export function isNewerBuild(otherHash: string): boolean {
  return BUILD_HASH !== otherHash;
}

// List of old build hashes that require forced updates
// Add hashes here for critical bug fixes that users must update to
export const FORCE_UPDATE_FROM_HASHES: string[] = [
  // Example: 'abc123def456' // Critical security fix from 2024-01-15
];
